var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomatedSupplyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8H12.5C12.2188 8 12 7.78125 12 7.5C12 7.25 12.2188 7 12.5 7H15.1875C14.1562 5.21875 12.2188 4 10 4C6.6875 4 4 6.6875 4 10C4 13.3125 6.6875 16 10 16C12.0938 16 13.9688 14.9062 15.0312 13.2812C15.125 13.125 15.3125 13 15.5 13C15.875 13 16.125 13.4062 15.9062 13.75C14.6875 15.7188 12.4688 17 10 17C6.125 17 3 13.875 3 10C3 6.15625 6.125 3 10 3C12.5312 3 14.75 4.375 16 6.40625V3.5C16 3.25 16.2188 3 16.5 3C16.75 3 17 3.25 17 3.5V7.5C17 7.78125 16.75 8 16.5 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedSupplyWhite);
export default __webpack_public_path__ + "static/media/automated-supply-white.c1950828c2023095d38eeab13676e0f1.svg";
export { ForwardRef as ReactComponent };